import axiosInstance from "./api";
import TokenService from "./utility";
import { refreshToken } from "./redux/actions/auth.actions";
//import { ConnectingAirportsOutlined } from '@mui/icons-material';

let MAX_REFRESH_RETRIES = 3;
let refreshRetries = 0;
const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const { dispatch } = store;
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      if (originalConfig?.url !== "auth/syslogin" && err.response) {
        // Access Token was expired
        if (
          err.response.status === 401 &&
          !originalConfig._retry &&
          refreshRetries <= MAX_REFRESH_RETRIES
        ) {
          originalConfig._retry = true;
          refreshRetries += 1;
          try {
            const rs = await axiosInstance.post("auth/token/refresh", {
              refresh: TokenService.getLocalRefreshToken(),
            });
            const accessToken = rs.data.access;
            dispatch(refreshToken(accessToken));
            TokenService.updateLocalAccessToken(accessToken);
            return axiosInstance(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        } else if (err.response.status >= 500) {
          return Promise.reject({
            ...err.response,
            message: `Sorry, something went wrong. Please try at a later time. If the issue still persists contact your support team.`,
          });
        }
      } else if (err.response) {
        if (err.response.status >= 500) {
          return Promise.reject({
            ...err.response,
            message: `Sorry, something went wrong. Please try at a later time. If the issue still persists contact your support team.`,
          });
        }
      }
      return Promise.reject(err);
    }
  );
};
export default setup;
